import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=b8a58826&scoped=true&"
import script from "./pic.vue?vue&type=script&lang=js&"
export * from "./pic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a58826",
  null
  
)

export default component.exports